/* FooterAIBrand.tsx generated by @compiled/babel-plugin v0.36.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import { RovoIcon } from '@atlaskit/logo';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { AtlassianIntelligenceLogo } from '../../AtlassianIntelligenceLogo/AtlassianIntelligenceLogo';
import messages from '../messages';
export function FooterAIBrand(_ref) {
  var brand = _ref.brand,
    appearance = _ref.appearance;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var shortDisclaimer = brand === 'rovo' ? messages.rovoCopyright : messages.atlassianIntelligenceCopyrightShort;
  var fullDisclaimer = brand === 'rovo' ? messages.rovoCopyright : messages.atlassianIntelligenceCopyright;
  return /*#__PURE__*/React.createElement(Inline, null, appearance !== 'small' && /*#__PURE__*/React.createElement(Box, null, appearance === 'medium' ? /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "color.text.subtle"
  }, formatMessage(shortDisclaimer)) : /*#__PURE__*/React.createElement(Text, {
    size: "small",
    color: "color.text.subtle"
  }, formatMessage(fullDisclaimer))), brand === 'rovo' ? /*#__PURE__*/React.createElement(RovoIcon, {
    label: formatMessage(fullDisclaimer),
    appearance: "neutral",
    size: "small"
  }) : /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
    label: formatMessage(fullDisclaimer),
    color: "var(--ds-icon-subtle, #626F86)",
    spacing: "spacious",
    LEGACY_fallbackIcon: AtlassianIntelligenceLogo,
    LEGACY_size: "medium"
  }));
}